import React, {
  ReactElement, useCallback, useEffect,
} from 'react';
import { SearchInputButton } from 'slovlex-idsk-react-components';
import LegMaterialListFilter from '../../../../model/legislativnyMaterial/LegMaterialListFilter';
import { SafeParameterSetter } from '../../../../types/SafeParameterSetter';

interface Props {
  filterCopy: LegMaterialListFilter;
  label?: string;
  ariaLabel?: string;
  filterSearchText: string;
  fieldName: keyof LegMaterialListFilter;
  onUpdateFieldCopy: SafeParameterSetter<LegMaterialListFilter>;
  className?: string;
  setFilter: (filter: LegMaterialListFilter) => void;
  type?: 'search' | 'search-number';
  maxLength?: number;
}

const SearchInput = ({
  filterCopy,
  label,
  ariaLabel,
  filterSearchText,
  onUpdateFieldCopy,
  fieldName,
  className,
  setFilter,
  type = 'search',
  maxLength,
}: Props): ReactElement => {
  const onSubmit = useCallback(async (): Promise<void> => {
    setFilter(filterCopy);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(filterCopy)]);

  useEffect(() => {
    const keyDownHandler = async (e): Promise<void> => {
      if (e.key === 'Enter' && e.target.tagName.toLowerCase() !== 'select') {
        e.preventDefault();
        await onSubmit();
      }
    };
    document.addEventListener('keydown', keyDownHandler);
    return () => {
      document.removeEventListener('keydown', keyDownHandler);
    };
  }, [onSubmit]);

  return (
    <SearchInputButton
      className={className}
      label={label}
      searchText={filterSearchText}
      setSearchText={(value: string) => onUpdateFieldCopy(fieldName, value)}
      onClearSearch={() => {
        onUpdateFieldCopy(fieldName, '');
      }}
      onButtonSubmit={onSubmit}
      type={type}
      maxLength={maxLength}
      ariaLabel={ariaLabel}
    />
  );
};

export default SearchInput;
